<div class="loading">
  @if (!primary) {
    <img
      src="../../../../assets/loading.svg"
      [width]="size || 50"
      alt="Carregando..."
      />
  }

  @if (primary) {
    <img
      src="../../../../assets/loading-primary.svg"
      [width]="size || 50"
      alt="Carregando..."
      />
  }

  @if (message) {
    <p class="loading--message">
      {{ message }}
    </p>
  }
</div>